import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import { DefaultImage, Media, MediaUpload } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"
import { Button, Modal } from "antd"
import { useState } from "react"
import { FeedbackProps, RenderConfig } from "./RenderConfig"

const ImageCard = ({ value, onChange }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const [url, setUrl] = useState(value)

  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: { url: string }) => {
    setUrl(media.url)
    onChange(media.url)
    setIsModalOpen(false)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
      <div className="flex flex-col gap-2">
        <input type="text" value={url} onChange={e => onChange(e.target.value)} placeholder="Image URL" readOnly />
        <div className="relative cursor-pointer group" onClick={() => openModal()}>
          <img
            src={url ? `${ADMIN_API_CONFIG.API_URL}${url}` : DefaultImage}
            alt="Slider Image"
            className="rounded-lg max-h-96 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden"
          />
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
            <span className="text-white text-3xl font-semibold drop-shadow-md">Change media</span>
          </div>
        </div>

        <Button
          onClick={() => openModal()}
          type="default"
          variant="outlined"
          className="bg-blue text-white p-4 border-[1px] border-blue rounded-[3px] hover:bg-blue-800 hover:text-white duration-300 my-2"
        >
          Select Image
        </Button>
      </div>

      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{
              backgroundColor: isChooseMedia ? "blue" : "initial",
              color: isChooseMedia ? "white" : "initial",
            }}
          >
            Select Media
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            Upload Media
          </Button>
        </div>

        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export const CaoCaoFeedback: ComponentConfig<FeedbackProps> = {
  label: "CaoCao | Feedback",
  fields: {
    heightFeedback: {
      label: "Height",
      type: "text",
    },
    gapFeedback: {
      label: "Gap",
      type: "text",
    },
    feedbackItems: {
      label: "Feedback Items",
      type: "array",
      arrayFields: {
        textField: {
          label: "Feedback Content",
          type: "object",
          objectFields: {
            title: {
              label: "Feedback Title",
              type: "text",
            },
            titleFontSize: {
              label: "Feedback Text Size",
              type: "text",
            },
            titleFontWeight: {
              label: "Feedback Text Weight",
              type: "text",
            },
            titleLineHeight: {
              label: "Feedback Line Height",
              type: "text",
            },
            content: {
              label: "Content",
              type: "text",
            },
            contentTextSize: {
              label: "Content Text Size",
              type: "text",
            },
            contentTextWeight: {
              label: "Content Text Weight",
              type: "text",
            },
            contentLineHeight: {
              label: "Content Line Height",
              type: "text",
            },
          },
        },
        textContainerStyles: {
          label: "Text Container Styles",
          type: "object",
          objectFields: {
            position: {
              label: "Position",
              type: "select",
              options: [
                { label: "Top Left", value: "top-left" },
                { label: "Top Right", value: "top-right" },
                { label: "Bottom Left", value: "bottom-left" },
                { label: "Bottom Right", value: "bottom-right" },
                { label: "Center", value: "center" },
              ],
            },
            color: {
              label: "Text Color",
              type: "text",
            },
            padding: {
              label: "Padding",
              type: "text",
            },
            gap: {
              label: "Gap",
              type: "text",
            },
          },
        },
        customerStyles: {
          label: "Customer Styles",
          type: "object",
          objectFields: {
            avatar: {
              label: "Avatar",
              type: "custom",
              render: props => <ImageCard {...props} />,
            },
            name: {
              label: "Name",
              type: "text",
            },
            nameFontSize: {
              label: "Name Font Size",
              type: "text",
            },
            nameFontWeight: {
              label: "Name Font Weight",
              type: "text",
            },
            nameLineHeight: {
              label: "Name Line Height",
              type: "text",
            },
            location: {
              label: "Location",
              type: "text",
            },
            locationFontSize: {
              label: "Location Font Size",
              type: "text",
            },
            locationFontWeight: {
              label: "Location Font Weight",
              type: "text",
            },
            locationLineHeight: {
              label: "Location Line Height",
              type: "text",
            },
            widthAvatar: {
              label: "Width Avatar",
              type: "text",
            },
            heightAvatar: {
              label: "Height Avatar",
              type: "text",
            },
            margin: {
              label: "Margin",
              type: "text",
            },
          },
        },
      },
    },
    type: {
      label: "Layout Type",
      type: "select",
      options: [
        { label: "Fluid", value: "fluid" },
        { label: "Custom", value: "custom" },
        { label: "Boxed", value: "boxed" },
      ],
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  ...RenderConfig,
}
